import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // initialize state
    this.scrolledValue = false
    this.windowHeight = window.innerHeight

    // make sure classes start off cleared
    document.documentElement.classList.remove("scrolled")

    // bind and listen
    this.onScroll = this.onScroll.bind(this)
    document.addEventListener("scroll", this.onScroll, { passive: true })

    // do one initial check (in case you land mid-page)
    this.onScroll()
  }

  disconnect() {
    document.removeEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const scrollTop = document.documentElement.scrollTop

    // toggle `.scrolled`
    if (scrollTop > 10 && !this.scrolledValue) {
      document.documentElement.classList.add("scrolled")
      this.scrolledValue = true
    } else if (scrollTop === 0 && this.scrolledValue) {
      document.documentElement.classList.remove("scrolled")
      this.scrolledValue = false
    }
  }
}
